import React from "react";
import { KTSVG } from "./KTSVG";

import DeleteIcon from "@mui/icons-material/Delete";

// Import svg Icon
// Add icon type constant to svgTypes
// add imported svg component to SVGIcons

export type SvgIconType =
  | "DOCUMENT_WITH_DOWNLOAD"
  | "NONCONFORMING"
  | "DELETE"
  | "BULLET_LINK"
  | "MENU"
  | "PILL"
  | "DOUBLE_ARROW_RIGHT"
  | "LOCK_CLOSE"
  | "LOCK_OPEN";

export const svgTypes: any = {
  DOCUMENT_WITH_DOWNLOAD: "/media/svg/reception/document.svg",
  NONCONFORMING: "/media/svg/reception/nonconforming.svg",
  DELETE: DeleteIcon,
  BULLET_LINK: "/media/icons/bullet_link.svg",
  MENU: "/media/icons/duotune/general/gen025.svg",
  PILL: "/media/icons/duotune/medicine/med002.svg",
  DOUBLE_ARROW_RIGHT: "/media/icons/duotune/arrows/arr080.svg",
  LOCK_CLOSE: "/media/icons/lock_close.svg",
  LOCK_OPEN: "/media/icons/lock_open.svg",
};

const SvgTypesValues = Object.keys(svgTypes);

const SvgIcon = (props: { type: SvgIconType; [key: string]: any }) => {
  const isAvailable = SvgTypesValues.includes(props?.type);

  if (!isAvailable) {
    console.warn("Svg icon is not available, please check svgTypes");
    return <></>;
  }

  const getSvgIcon = () => {
    const SvgPath = svgTypes[props.type];

    if (typeof SvgPath !== "string") {
      return <SvgPath {...props} />;
    }

    return (
      <KTSVG path={SvgPath} className="svg-icon-1" fill="black" {...props} />
    );
  };

  return getSvgIcon();
};

export default SvgIcon;
